import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import {
  SCHEDULE_ITEM_TYPES,
  SCHEDULE_TYPES_HUMAN_VALUES,
  SCHEDULE_TYPES
} from 'ducks/tenancy';

import {formatDate} from 'utils/datetime';

import Alert from 'components/Alert';
import Table from 'components/Table';
import Money from 'components/Money';
import PaymentStatusTag from 'components/PaymentStatusTag';
import ClickIconWithNoPropagation from 'components/ClickIconWithNoPropagation';

const RefundRow = ({
  refund,
  handleRowClick,
  redirectToBookingDetail,
  advancedMode
}) => {
  const {refundDetails} = refund;

  return (
    <Table.Row
      className={classNames('scheduleRow', {
        highlighted: refund.highlighted
      })}
      onClick={() =>
        handleRowClick({
          item: SCHEDULE_ITEM_TYPES.REFUND,
          itemId: refund.id,
          scheduleType: SCHEDULE_TYPES[refund.scheduleType],
          tenancyId: refundDetails.tenancyId
        })
      }>
      <Table.Cell className="booking">
        <ClickIconWithNoPropagation
          onClick={() =>
            redirectToBookingDetail({bookingId: refund.bookingId})
          }>
          <div className="colab-bold">#{refund.bookingId}</div>
        </ClickIconWithNoPropagation>
      </Table.Cell>
      <Table.Cell className="date">{formatDate(refund.date)}</Table.Cell>
      {advancedMode && <Table.Cell className="dueDate" />}
      <Table.Cell className="type">
        <div className="colab-centered-v">
          {refundDetails.hasXeroErrors && <Alert />}
          <div className="colab-centered"> Refund</div>
        </div>
      </Table.Cell>
      <Table.Cell className="description">{refundDetails.reference}</Table.Cell>
      <Table.Cell className="category">
        {_.get(SCHEDULE_TYPES_HUMAN_VALUES, refund.scheduleType)}
      </Table.Cell>
      <Table.Cell className="status">
        <PaymentStatusTag status={refundDetails.status} />
      </Table.Cell>
      {advancedMode && <Table.Cell className="due" />}
      <Table.Cell className="amount payment">
        <Money
          amount={-refund.amount}
          balance
          className={classNames({
            strikeThrough: refundDetails.voided
          })}
        />
      </Table.Cell>
      <Table.Cell className="balance">
        <Money amount={refund.balance} balance />
      </Table.Cell>
      <Table.Cell className="mode" />
    </Table.Row>
  );
};

export default RefundRow;
